import styled, { css } from 'styled-components'
import { Container } from '../../atoms/GridSystem'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.styles';

interface Theme {
  rem: (value: number) => string;
  mediaQuery: {
    lg: (styles: string, important?: boolean) => string;
    xl: (styles: string, important?: boolean) => string;
  };
  colorScheme: {
    [key: string]: {
      surface: {
        inside: string;
        outsie: string;
        text: {
          base: {
            primary: string;
            secondary: string;
            tertiary: string;
          };
        };
      };
    };
  };
}

interface BannerProps {
  theme: Theme;
  tabItem?: boolean;
}

interface BannerWrapperProps {
  theme: Theme;
  newsletter?: boolean;
  colorScheme?: string;
}

interface BannerMaskWrapperProps {
  theme: Theme;
  maskType?: string;
}

export const Banner = styled(Container)<BannerProps>`

  ${({ theme, tabItem }) => theme.mediaQuery.lg(`
    text-align: ${tabItem ? 'left' : 'center'};
  `, true)}
`

export const BannerWrapper = styled.div<BannerWrapperProps>`
  border-radius: ${({ theme }) => theme.rem(24)};
  padding: ${({ theme }) => theme.rem(24)};

  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(60)};
  `)}

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary}!important;
  }

  ${({ theme, colorScheme }) => css`
    background-color: ${theme.colorScheme[`${colorScheme}`].surface.inside};
    
  `}
`

export const BannerMaskWrapper = styled.div<BannerMaskWrapperProps>`
  width: 100%;
  position: relative;
  height: 100%;
  max-height: ${({ theme }) => theme.rem(500)};
  margin: 0 auto;
  aspect-ratio: 4 / 4;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.rem(8)};

  ${({ maskType }) => maskType && css`
    mask-image: url('/masks/mask-${maskType}.svg');
    mask-size: 100%;
    mask-repeat: no-repeat;
    mask-position: center;
  `}

  ${({ theme }) => theme.mediaQuery.xl(`
    max-width: unset;
    max-height: unset;
  `)};

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const BannerIconWrapper = styled.div`
  i {
    font-size: ${({ theme }) => theme.rem(16)};
  }
`

export const BannerContentWrapper = styled.div`
  text-align: left;

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-right: ${theme.rem(48)};
  `)}

  a {
    width: 100%;
  }
`